// packages Import
import { Paper, Table, TableContainer } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { TableHeaderProps } from "../../interfaceTypes";

export const CaseStickyTable: FC<TableHeaderProps> = ({ children, pagination, height, loading }): JSX.Element => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    sessionStorage.setItem('scrollPosition', scrollRef?.current?.scrollTop?.toString()!);
  };

  useEffect(() => {
    if (!loading) {
      const storedScrollPosition = sessionStorage.getItem('scrollPosition');

      setTimeout(() => {
        if (storedScrollPosition !== null && scrollRef.current) {
          scrollRef.current.scrollTo(0, parseInt(storedScrollPosition));
          sessionStorage.removeItem('scrollPosition');
        }
      }, 500);
    }
  }, [loading]);

  return (<Paper sx={{ width: '100%', overflow: 'hidden' }}>
    <TableContainer sx={{ height: `calc(100vh - ${height || '342px'})`, scrollBehavior: 'smooth' }} ref={scrollRef} onClick={handleScroll}>
      <Table stickyHeader aria-label="sticky table">
        {children}
      </Table>
    </TableContainer>
    {pagination}
  </Paper>
  )
}